import { size } from 'mol-ui';
import styled from 'styled-components';
import { Col, Row } from 'reactstrap';

export const Avatar = styled.img`
    border-radius: 100%;
    height: 100px;
    object-fit: cover;
    width: 100px;
`;

export const InputHidden = styled.input `
    display: none;
`;

export const ProfileContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
    width: 100%;
`;

export const ProfileIcon = styled.div`
    background: ${ ({ theme: { disabledColor } }) => disabledColor };
    border-radius: 100%;
    cursor: pointer;
    align-items: center;
    display: flex;
    height: 100px;
    justify-content: center;
    margin-bottom: 5px;
    width: 100px;
`;

export const ProfileText = styled.p`
    color: ${ ({ theme: { opacityColor } }) => opacityColor };    
    cursor: pointer;
    margin-top: 10px;
`;

export const ResponsiveCol = styled(Col)`
    align-items: center;
    display: flex;
    margin-top: 10px;
     ${ size.xs(`
        align-items: center;
        display: flex;
        justify-content: flex-end;
    `) }
`;
export const StyledRow = styled(Row)`
    margin-top: ${ ({ marginTop = '0px' }) => marginTop };
    padding: 0px;
`;

